import type { ObjectSelectValue } from "@components/ObjectSelect";
import { create } from "zustand";

interface ObjectStore {
  selectedObject: ObjectSelectValue | undefined;
  /** True after the first auto-select has happened in this session */
  _initialized: boolean;
  setSelectedObject: (value: ObjectSelectValue | undefined) => void;
}

export const useObjectStore = create<ObjectStore>()((set) => ({
  selectedObject: undefined,
  _initialized: false,
  setSelectedObject: (selectedObject) => set({ selectedObject }),
}));
